import React, { useEffect, useState } from 'react';
import { adminActions } from '../../_global/js/_api';

export const Admin = () => {
    const [wowChallenge, setWowChallenge] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [wowChallenge50, setWowChallenge50] = useState(0);
    const [wowChallenge100, setWowChallenge100] = useState(0);
    useEffect(() => {
        adminActions().then((data) => {
            console.log(data)
            const {profiles, wowData} = data;
            const numberOfStudents = wowData.filter(student => student.length);
            const wow50 = profiles.filter(profile => profile.wowChallenge && profile.wowChallenge[0] === '50');
            const wow100 = profiles.filter(profile => profile.wowChallenge && profile.wowChallenge[0] === '100');
            setTotalUsers(profiles.length);
            setWowChallenge(numberOfStudents.length);
            setWowChallenge50(wow50.length);
            setWowChallenge100(wow100.length);
        })
        
        console.log('hi');
    },[])
    return (
        <div className="admin__wrapper">
            { wowChallenge ? 
            <>
                <p>Num of users <br />{totalUsers}</p>
                <p>Started <br />{wowChallenge}</p>
                <p>50 hours <br />{wowChallenge50}</p>
                <p>100 hours <br />{wowChallenge100}</p>
            </>
            :
            <>
                <p>Fetching user data</p>
                <div className="loading" />
            </>
            }
        </div>
    )
}